import * as React from 'react';
import '../styles/App.css';

class FooterContent extends React.Component {
  render() {
    return (
        <div className="FooterContent"/>
    );
  }
}

export default FooterContent;


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/FooterContent.tsx